import { isObject } from './checks'

export const reverseObjectKeysAndValues = (
  obj: Record<string, string>
): Record<string, string> | unknown => {
  if (!isObject(obj)) {
    return obj
  }
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[value] = key
    return acc
  }, {})
}
